import styled from 'styled-components/macro';

export const Hr = styled.div`
    ${({ theme }) => `
        width: 100%;
        height: 1px;
        background-color: ${theme.color.bgSearch};
    `}
`;
